module.exports = __webpack_public_path__ + "06d8ba2dae920dca6964b6c994bb2d56.MP3";